import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {
  private readonly RootURL=environment.baseUrl;

  constructor(private http:HttpClient) { }

  GetLowInventroyProducts():Observable<any>{
    return this.http.get<any>(this.RootURL+'/Product/GetLowInventoryProducts');
  }

  AddProductStock(postData: any): Observable<any> {
    return this.http.post<any>(this.RootURL + '/Product/AddProductStock', postData);
  }

  enableDisabledInventory(productItemId:number):Observable<any>{
    return this.http.get<any>(this.RootURL+'/Product/enableDisableInventory',{params:{productItemId}})
  }
}
